var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4486 0.137221C19.0866 0.148376 18.7432 0.297198 18.4914 0.551882C15.0811 3.89265 11.6683 7.21702 8.2542 10.5584L2.96708 6.25179C2.68297 6.02037 2.31653 5.90882 1.94814 5.9418C1.57977 5.97456 1.24003 6.14926 1.00331 6.42696C0.766791 6.70491 0.652907 7.0631 0.686414 7.42318C0.720167 7.78325 0.898891 8.11534 1.183 8.34648L7.44915 13.4506C7.71675 13.6695 8.05866 13.7822 8.4071 13.7665C8.75557 13.7506 9.08532 13.6077 9.3313 13.3656C13.0424 9.73028 16.7556 6.11655 20.4711 2.47682C20.7433 2.21976 20.8968 1.86542 20.8963 1.49537C20.8958 1.12534 20.7412 0.771438 20.468 0.51532C20.1948 0.259215 19.8267 0.122734 19.4484 0.137445L19.4486 0.137221Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b93059dc5dffd0c3629b6af48bc837cc.svg";
export { ForwardRef as ReactComponent };